import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-card-header-title-subtitle',
    standalone: true,
    imports: [CommonModule, IonicModule, TranslateModule],
    templateUrl: './card-header-title-subtitle.component.html',
    styleUrl: './card-header-title-subtitle.component.scss',
})
export class CardHeaderTitleSubtitleComponent {
    @Input() icon!: string;
    @Input() title!: string;
    @Input() subtitle!: string;

    constructor() {}

}
